export const MAX_BEESWAX_V2_PAGE_SIZE = 1000;
